import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ServerDiscovery from '../services/ServerDiscovery';
import { applyAuthPayload } from '../utils/auth';
import { trackEvent } from '../utils/analytics';

function AuthReset() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setError('This reset link is missing a token. Request a new one from the sign-in form.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    setError('');
    try {
      const base = await ServerDiscovery.discoverHttpBase();
      const res = await fetch(`${base}/auth/reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not reset password');
      }
      applyAuthPayload(data);
      trackEvent('email_password_reset');
      navigate('/account', { replace: true });
    } catch (err) {
      setError(err.message || String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="lng-page">
      <header className="lng-topbar">
        <Link to="/" className="lng-back" aria-label="Back to LangShazam">←</Link>
        <h1 className="lng-brand">LangShazam</h1>
        <div className="lng-topbar-actions" />
      </header>
      <section className="lng-auth-card">
        <h2 className="lng-modal-title">Choose a new password</h2>
        {!token ? (
          <p className="lng-verify-hint">
            This link is incomplete. Go to <Link to="/account">Account</Link> and use Forgot password.
          </p>
        ) : (
          <form className="lng-auth-form" onSubmit={onSubmit}>
            <input
              className="lng-input"
              type="password"
              autoComplete="new-password"
              placeholder="New password (8+ characters)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
              disabled={busy}
            />
            <input
              className="lng-input"
              type="password"
              autoComplete="new-password"
              placeholder="Confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              minLength={8}
              required
              disabled={busy}
            />
            <button
              type="submit"
              className="lng-google-btn lng-email-btn"
              disabled={busy || password.length < 8}
            >
              {busy ? 'Saving…' : 'Update password'}
            </button>
          </form>
        )}
        {error && <p className="lng-inline-error">{error}</p>}
      </section>
    </div>
  );
}

export default AuthReset;
